import React from 'react';
import Icon from '../Icon/Icon';
import { HTMLPrinterActionButtonProps } from './types';
import ActionButton from '../ActionButton';

function HTMLPrinterActionButton({
  action,
  onClick,
}: HTMLPrinterActionButtonProps) {
  const { variant, color, label, icon } = action;

  return (
    <ActionButton
      variant={variant}
      color={color}
      type="button"
      onClick={onClick}
      startIcon={icon && <Icon definition={icon} />}
    >
      {label}
    </ActionButton>
  );
}

export default HTMLPrinterActionButton;
